//加密工具类
import CryptoJS from "crypto-js"
//配置文件json 存储key 请求地址等配置信息
import configJson from "./webhisconfig.json"

const AESKey = configJson.AES_KEY
const IV = configJson.IV

//加密
export function encryptResult(funcname, data) {

    const encData = encrypt(data, AESKey, IV);
    const timestamp = Date.now();
    const nonestr = generateRandomString(10);
    const key = GetSignKey(timestamp.toString(), nonestr)
    const source = `funcname=${funcname}&timestamp=${timestamp}&nonestr=${nonestr}&data=${encData}&${key}&`;
    const sign = CryptoJS.MD5(source).toString().toUpperCase();
    const result = {
        funcname: funcname,
        timestamp: timestamp.toString(),
        nonestr: nonestr,
        sign: sign,
        data: encData
    }
    // console.log(result)

    return result;
}

//解密
export function decryptInput(commonEncryInput) {
    if (typeof commonEncryInput === 'string') {
        commonEncryInput = JSON.parse(commonEncryInput);
    }
    // commonEncryInput = JSON.parse(commonEncryInput);
    const pk = GetSignKey(commonEncryInput.timestamp, commonEncryInput.nonestr);
    const flag = checkSign(commonEncryInput, pk);
    if (!flag) {
        return "验签失败"
    } else {
        // console.log("验签通过");
        // console.log(commonEncryInput.data);
    }
    // try {
    const decData = decrypt(commonEncryInput.data, AESKey, IV);

    return decData;
    // } catch (error) {
    //     // console.error(error);
    //     return "解密失败";
    // }


}

//解密  data：要加密解密的数据，AES_KEY：密钥，IV:偏移量
function decrypt(data, AES_KEY, IV) {
    // const encryptedData = CryptoJS.enc.Base64.parse(data);
    const key = CryptoJS.enc.Utf8.parse(AES_KEY);
    const iv = CryptoJS.enc.Utf8.parse(IV);
    const decrypt = CryptoJS.AES.decrypt(data, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    // console.log(decrypt);

    let res = "";
    try {
        const objIndex = decrypt.lastIndexOf("}");
        const arrIndex = decrypt.lastIndexOf("]");
        if (objIndex > arrIndex) {
            res = JSON.parse(decrypt.substring(0, objIndex + 1));
        } else {
            res = JSON.parse(decrypt.substring(0, arrIndex + 1));
        }

    } catch (err) {
        res = decrypt;
    }
    return res;
}


// 加密
function encrypt(data, AES_KEY, IV) {
    try {
        var keyBytes = CryptoJS.enc.Utf8.parse(AES_KEY);
        var ivBytes = CryptoJS.enc.Utf8.parse(IV);

        var encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), keyBytes, { iv: ivBytes });

        return encrypted.toString();
    } catch (error) {
        //    console.error(error);
        return null;
    }
}


//生成随机字符串
function generateRandomString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}


function GetSignKey(timestamp, nonestr) {
    //1:获取时间戳
    let now = timestamp;
    let nowarr = now.toString().split('');
    let nonestrarr = nonestr.toString().split('');

    //2：将奇数位相加合是奇数还是偶数
    let sum = 0;
    for (let i = 0; i < nowarr.length; i++) {
        if (i % 2 == 0) {
            sum += nowarr[i].charCodeAt(0);
        }
    }

    let token = "";
    let token_nonestr = "";
    if (sum % 2 === 0) {
        for (let i = 0; i < nowarr.length; i++) {
            if (i % 2 !== 0) {
                token += nowarr[i];
            }
        }

        for (let i = 0; i < nonestrarr.length; i++) {
            if (nonestrarr[i].charCodeAt(0) % 2 !== 0) {
                token_nonestr += nonestrarr[i];
            }
        }
    } else {
        for (let i = 0; i < nowarr.length; i++) {
            if (i % 2 === 0) {
                token += nowarr[i];
            }
        }

        for (let i = 0; i < nonestrarr.length; i++) {
            if (nonestrarr[i].charCodeAt(0) % 2 === 0) {
                token_nonestr += nonestrarr[i];
            }
        }
    }


    //3:将token进行md5
    let ss = "{" + CryptoJS.MD5(token_nonestr).toString().toUpperCase() + "&" + CryptoJS.MD5(timestamp.toString()).toString().toUpperCase() + "&" + CryptoJS.MD5(token).toString().toUpperCase() + "}";

    return CryptoJS.MD5(ss).toString().toUpperCase();
}

function checkSign(comm, key) {
    const source = `${comm.code},${comm.message},${comm.timestamp},${comm.nonestr},${comm.data},${key}&`
    if (comm.sign === CryptoJS.MD5(source).toString().toUpperCase()) {
        return true;
    }
    return false;
}